<template>
  <div class="page vino">
    <ListingList
      :indexes="indexes"
      :pageHandle="vinoPage.typeHandle"
      :categories="categories"
      :subcategories="subcategories"
      :introSection="vinoPage.sezioneIntroProdotti[0]"
      :parentIntroSectionImage="vinoPage.sezioneIntroProdotti[0].portrait"
    />
    <ListingIntro
      :introSection="vinoPage.sezioneIntroProdotti[0]"
      class="hide-for-large"
    />
    <PagesVinoBirraPreFooterSection
      :preFooterSection="vinoPage.sezionePreFooter[0]"
    />
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import queries from '@/graphql/craft/queries/index.js'
import { useVinoData } from '~/composables/vino-data.js'

const indexes = ['section_vino']

const { configuration } = useStore()

const query = queries.vinoPage.getVinoPage

const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)

if (!data.value.vinoPageEntries?.[0]) {
  throw createError({ statusCode: 404 })
}
const vinoPage = computed(() => data.value.vinoPageEntries?.[0])

const { categories, subcategories } = useVinoData(data)

const seo = computed(() => data.value?.vinoPageEntries?.[0]?.seo || {})

useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>
